import useUsersConfig from "hooks/useUsersConfig";
import { useMemo } from "react";

const filterConfigMap = {
  emailFilterEnabled: ["PA"],
  orgIdFilterEnabled: ["PA"],
};

function useReportFilterConfig() {
  const { loggedInRole } = useUsersConfig();
  const filterConfig = useMemo(() => {
    return Object.keys(filterConfigMap).reduce((acc, key) => {
      acc[key] = filterConfigMap[key]?.includes(loggedInRole);
      return acc;
    }, {});
  }, [loggedInRole]);

  if (typeof filterConfig !== "object") {
    console.log(`[ERROR] filterConfig not an object:`, filterConfig);
  }
  return filterConfig || {};
}

export default useReportFilterConfig;
